import { useEffect, useState } from 'preact/hooks';
import { api } from '../api.js';
import { t } from '../i18n/index.js';
import type { MyStatsResponse } from '../../shared/protocol.js';

/** The player's statistics and experience level (suunnitelma.md sections 22–23). */
export function StatsCard() {
  const [stats, setStats] = useState<MyStatsResponse | null>(null);

  useEffect(() => {
    api<MyStatsResponse>('GET', '/api/me/stats')
      .then(setStats)
      .catch(() => setStats(null));
  }, []);

  if (!stats) return null;
  const s = stats.total;
  const winPct = s.played > 0 ? Math.round((s.wins / s.played) * 100) : 0;

  return (
    <section class="card stats">
      <div class="section-head">
        <h2>{t.stats.title}</h2>
        <div class="level-badge">
          <span class="muted">{t.stats.level}</span>
          <strong>{t.levels[stats.level]}</strong>
        </div>
      </div>
      {s.played === 0 ? (
        <p class="muted">{t.stats.none}</p>
      ) : (
        <div class="stat-grid">
          <div class="stat">
            <span class="stat-value">{s.played}</span>
            <span class="stat-label">{t.stats.played}</span>
          </div>
          <div class="stat">
            <span class="stat-value">{s.wins}</span>
            <span class="stat-label">{t.stats.wins}</span>
          </div>
          <div class="stat">
            <span class="stat-value">{s.losses}</span>
            <span class="stat-label">{t.stats.losses}</span>
          </div>
          <div class="stat">
            <span class="stat-value">{s.draws}</span>
            <span class="stat-label">{t.stats.draws}</span>
          </div>
          <div class="stat">
            <span class="stat-value">{winPct}%</span>
            <span class="stat-label">{t.stats.winPct}</span>
          </div>
          <div class="stat">
            <span class="stat-value">{s.resignations}</span>
            <span class="stat-label">{t.stats.resignations}</span>
          </div>
          <div class="stat">
            <span class="stat-value">{s.timeouts}</span>
            <span class="stat-label">{t.stats.timeouts}</span>
          </div>
        </div>
      )}
      {stats.byGame
        .filter((g) => g.bestScore !== null)
        .map((g) => (
          <p class="best-score">🏆 {t.stats.bestScore(t.games[g.gameType].name, g.bestScore!)}</p>
        ))}
      <p class="muted next-level">
        {stats.gamesToNextLevel === null ? t.stats.maxLevel : t.stats.nextLevel(stats.gamesToNextLevel)}
      </p>
    </section>
  );
}
